<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        EDIT {{ address.type }} ADDRESS
      </div>
      <button
        class="ac-close-button"
        @click="closeAddressModal"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div>
        <div>Address 1</div>
        <SACInput
          class="margin-bottom"
          field="address1"
          placeholder="Enter Street Address"
          :value="address.address1"
          :change="changeAddress"
        />
      </div>
      <div class="margin-top-16">
        <div>Address 2</div>
        <SACInput
          class="margin-bottom"
          field="address2"
          placeholder="Enter Apt #, Suite #, etc"
          :value="address.address2"
          :change="changeAddress"
        />
      </div>
      <div class="margin-top-16">
        <div>City</div>
        <SACInput
          class="margin-bottom"
          field="city"
          placeholder="Enter City"
          :value="address.city"
          :change="changeAddress"
        />
      </div>
      <div class="margin-top-16">
        <div>Country</div>
        <SACInput
          class="margin-bottom"
          field="country"
          placeholder="Enter Country"
          :value="address.country"
          :change="changeAddress"
        />
      </div>
      <div class="margin-top-16">
        <div>State</div>
        <SACDropdown
          class="margin-bottom"
          :options="states"
          :value="address.state"
          optionLabel="state"
          optionValue="abbreviation"
          placeholder="Select State"
          field="state"
          :change="changeAddress"
        />
      </div>
      <div class="margin-top-16">
        <div>Zip</div>
        <SACInput
          field="zip"
          placeholder="Enter Zip"
          :value="address.zip"
          :change="changeAddress"
        />
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="updateAddress"
      >
        Update
      </button>
    </div>
    <ProcessOverlay
      :show="isProcessing"
      text="Updating Address"
      overlayClass="ac-overlay"
    />
  </div>
</template>
<script>
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import SACInput from '@shared/components/sac/SACInput.vue';
import { mapState } from 'vuex';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'EditAddressForm',
  components: { ProcessOverlay, SACInput, SACDropdown },
  props: {
    memberAddress: {
      type: Object,
    },
  },
  data() {
    return {
      isProcessing: false,
      address: { ...this.memberAddress },
    };
  },
  computed: {
    ...mapState({
      states: (state) => state.general.states,
    }),
  },
  methods: {
    changeAddress(field, value) {
      if (field === 'address') {
        this.address = { ...this.address, ...value };
      } else {
        this.address[field] = value;
      }
    },
    closeAddressModal() {
      this.$store.dispatch('resetCustomerDetailModal');
    },
    async updateAddress() {
      try {
        this.isProcessing = true;
        await this.$store.dispatch('updateAddressByType', this.address);
      } catch (err) {
        throw err;
      } finally {
        this.isProcessing = false;
        this.closeAddressModal();
      }
    },
  },
};
</script>

<style scoped lang="scss">

</style>
